/* Simple Pledge Produktseite (10.10.2026) – Logik zu snippets/sp-pdp.liquid */
(function () {
  'use strict';
  var root = document.querySelector('[data-sp-pdp]');
  if (!root || root.dataset.bound) return;
  root.dataset.bound = '1';

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var fmt = function (c) { return (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); };
  var ds = root.dataset;
  var data = { variants: [] };
  try { data = JSON.parse($('[data-spp-data]').textContent); } catch (e) {}
  var byId = {}; data.variants.forEach(function (v) { byId[v.id] = v; });

  var endOfDay = function (d) { return d ? new Date(d + 'T23:59:59+01:00').getTime() : 0; };
  var duoActive = ds.duoActive === 'true' && Date.now() <= endOfDay(ds.duoUntil);
  var trioOff = duoActive ? parseInt(ds.trioOff || '0', 10) : 0;
  var ship = parseInt(ds.ship || '0', 10), gift = parseInt(ds.gift || '0', 10);
  var shipFrom2 = parseInt(ds.shipUntil || '0', 10) * 1000 > Date.now();
  var isRope = /Seil/.test(ds.type || '');

  var firstAvail = (data.variants.filter(function (v) { return v.a; })[0] || data.variants[0] || {}).id;
  var onBtn = $('[data-spp-slot="1"] .spp-swb.is-on');
  var startId = (onBtn && parseInt(onBtn.dataset.vid, 10)) || firstAvail;
  var state = { qty: 1, slots: [null, startId, startId, startId], cart: null, busy: false };

  /* ---------- Mehrere Optionen (Pills) ---------- */
  var optSel = $$('[data-spp-option]').map(function (o) { var on = $('.spp-pill.is-on', o); return on ? on.dataset.val : null; });
  $$('[data-spp-option]').forEach(function (o, i) {
    $$('.spp-pill', o).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.spp-pill', o).forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on'); optSel[i] = b.dataset.val;
        var lbl = $('[data-spp-oval]', o); if (lbl) lbl.textContent = b.dataset.val;
        var v = data.variants.filter(function (x) { return x.o.every(function (val, j) { return optSel[j] == null || val === optSel[j]; }); })[0];
        if (v) { state.slots[1] = v.id; onMain(); render(); }
      });
    });
  });

  /* ---------- Farb-Kacheln je Stück ---------- */
  $$('[data-spp-slot]').forEach(function (slotEl) {
    var n = parseInt(slotEl.dataset.sppSlot, 10);
    $$('.spp-swb', slotEl).forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        $$('.spp-swb', slotEl).forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-on'); b.setAttribute('aria-checked', 'true');
        state.slots[n] = parseInt(b.dataset.vid, 10);
        var nm = $('[data-spp-vname]', slotEl); if (nm) nm.textContent = byId[state.slots[n]].t;
        if (n === 1) onMain();
        render();
      });
    });
  });

  /* Hauptvariante gewechselt: Bild, URL, Bestand, Set-Variante */
  function onMain() {
    var v = byId[state.slots[1]]; if (!v) return;
    var img = $('[data-spp-main]');
    if (img && v.img) { img.src = v.img; if (v.set) img.srcset = v.set; img.alt = img.alt.split(' – ')[0] + ' – ' + v.t; }
    goTo(0);
    try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
    // Back-in-Stock-App über die neue Variante informieren
    var bis = document.getElementById('BIS_trigger');
    if (bis && bis.classList.contains('spp-notify')) { bis.setAttribute('data-variant-id', v.id); bis.style.display = v.a ? 'none' : ''; }
    // Stück 2/3 folgen der Hauptfarbe, solange dort nichts anderes gewählt wurde
    [2, 3].forEach(function (n) {
      var el = $('[data-spp-slot="' + n + '"]'); if (!el || el.dataset.touched) return;
      var b = $('.spp-swb[data-vid="' + v.id + '"]', el);
      if (b && !b.disabled) { $$('.spp-swb', el).forEach(function (x) { x.classList.remove('is-on'); }); b.classList.add('is-on'); state.slots[n] = v.id; var nm = $('[data-spp-vname]', el); if (nm) nm.textContent = v.t; }
    });
  }
  [2, 3].forEach(function (n) { var el = $('[data-spp-slot="' + n + '"]'); if (el) el.addEventListener('click', function (e) { if (e.target.closest('.spp-swb')) el.dataset.touched = '1'; }, true); });

  /* ---------- Menge ---------- */
  $$('.spp-q').forEach(function (b) {
    b.addEventListener('click', function () {
      $$('.spp-q').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-checked', 'false'); });
      b.classList.add('is-on'); b.setAttribute('aria-checked', 'true');
      state.qty = parseInt(b.dataset.q, 10); render();
    });
  });

  function calc(q) {
    var a = []; for (var i = 1; i <= q; i++) { var v = byId[state.slots[i]] || byId[state.slots[1]]; a.push(v ? v.p : 0); }
    var sum = a.reduce(function (x, y) { return x + y; }, 0), off = 0;
    // 22.10.2026: ohne Trio-Code (DUO ab 27.10.) gilt auch bei 3 Stück: ein Teil −50 %, dafür kein Gratis-Armreif (zwei BXGY schließen sich aus)
    var duo3 = duoActive && q >= 3 && !trioOff;
    if (duoActive && (q === 2 || duo3)) off = Math.round(Math.min.apply(null, a) / 2);
    if (q === 3 && trioOff) off = trioOff;
    return { sum: sum, total: sum - off, off: off, giftOk: !duo3 && gift > 0 && sum >= gift };
  }

  /* ---------- Zusatzartikel ---------- */
  var setBox = $('[data-spp-set]'), wrapBox = $('[data-spp-wrap]');
  var setData = null; try { setData = JSON.parse($('[data-spp-set-data]').textContent); } catch (e) {}
  var wrapEl = wrapBox ? wrapBox.closest('[data-wrap-vid]') : null;
  var wrapVid = wrapEl ? parseInt(wrapEl.dataset.wrapVid, 10) : 0, wrapPrice = wrapEl ? parseInt(wrapEl.dataset.wrapPrice, 10) : 0;
  function setVariant() {
    if (!setData) return null;
    var main = byId[state.slots[1]], av = setData.variants.filter(function (v) { return v.a; });
    return av.filter(function (v) { return main && v.t === main.t; })[0] || av[0] || null;
  }
  function wrapInCart() { return !!(state.cart && wrapVid && state.cart.items.some(function (i) { return i.variant_id === wrapVid; })); }
  [setBox, wrapBox].forEach(function (b) { if (b) b.addEventListener('change', render); });

  /* ---------- Lieferdatum (Werktage) ---------- */
  function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function deliveryText() {
    var f = { weekday: 'short', day: '2-digit', month: '2-digit' }, now = new Date();
    return 'Auf Lager – Lieferung voraussichtlich ' + addBiz(now, parseInt(ds.dmin || '1', 10)).toLocaleDateString('de-DE', f) + ' – ' + addBiz(now, parseInt(ds.dmax || '3', 10)).toLocaleDateString('de-DE', f);
  }

  /* ---------- Darstellung ---------- */
  function txt(el, t) { if (el) el.textContent = t; }
  function render() {
    var main = byId[state.slots[1]] || {};
    var c = calc(state.qty);

    txt($('[data-spp-price]'), fmt(main.p || 0));
    var cmp = $('[data-spp-compare]'); if (cmp) { cmp.hidden = !(main.c > main.p); if (main.c > main.p) cmp.textContent = fmt(main.c); }
    var low = $('[data-spp-low]'); if (low) { low.hidden = !main.low; if (main.low) low.textContent = 'Nur noch ' + main.low + ' verfügbar'; }

    // Mengen-Karten
    $$('.spp-q').forEach(function (b) {
      var q = parseInt(b.dataset.q, 10), k = calc(q);
      txt($('[data-q-price]', b), fmt(k.total));
      var s = $('[data-q-strike]', b); s.hidden = !k.off; if (k.off) s.textContent = fmt(k.sum);
      var badge = $('[data-q-badge]', b), note = '', bt = '';
      if (q === 2) { if (duoActive) { bt = '−50 % aufs 2.'; note = 'statt ' + fmt(k.sum); } else if (k.total >= ship || shipFrom2) note = 'Gratis-Versand'; }
      if (q === 3) {
        if (k.giftOk) { bt = '+ Geschenk'; note = 'Armreif gratis dazu'; }
        else if (k.off) { if (duoActive && !trioOff) bt = '−50 % aufs 2.'; note = 'statt ' + fmt(k.sum); }
        else if (k.total >= ship) note = 'Gratis-Versand';
      }
      badge.hidden = !bt; badge.textContent = bt;
      txt($('[data-q-note]', b), note);
    });
    [2, 3].forEach(function (n) { var el = $('[data-spp-slot="' + n + '"]'); if (el) el.hidden = state.qty < n; });
    var l1 = $('[data-spp-slot="1"] [data-spp-slot-label]');
    if (l1) { if (!l1.dataset.orig) l1.dataset.orig = l1.textContent; l1.textContent = state.qty > 1 ? (isRope ? 'Armband 1' : (/Armreif/.test(ds.type || '') ? 'Armreif 1' : 'Stück 1')) : l1.dataset.orig; }

    // Set-Preis passend zur Farbe
    var sv = setVariant(); txt($('[data-spp-set-price]'), sv ? '+' + fmt(sv.p) : '');
    var addons = (setBox && setBox.checked && sv ? sv.p : 0) + (wrapBox && wrapBox.checked && !wrapInCart() ? wrapPrice : 0);
    var total = c.total + addons;

    // Kauf-Button
    var avail = true; for (var i = 1; i <= state.qty; i++) { var vv = byId[state.slots[i]]; if (!vv || !vv.a) avail = false; }
    var atc = $('[data-spp-atc]'), sb = $('[data-spp-sticky-btn]');
    atc.disabled = !avail || state.busy; if (sb) sb.disabled = !avail || state.busy;
    txt($('[data-spp-atc-label]'), !avail ? 'Ausverkauft' : (state.qty > 1 ? state.qty + ' in den Warenkorb' : 'In den Warenkorb'));
    txt($('[data-spp-atc-price]'), avail ? fmt(total) : '');
    txt($('[data-spp-sticky-price]'), fmt(total));
    txt($('[data-spp-delivery]'), main.a ? deliveryText() : 'Diese Farbe ist gerade ausverkauft – bitte eine andere wählen');

    // Versand-/Geschenk-Fortschritt (inkl. Warenkorb)
    // Gratis-Versand zählt nach Rabatt (Shopify-Versandstufe 49 €), Gratis-Armreif nach Warenwert vor Rabatt
    var base = 0, units = 0, shipBase = state.cart ? (state.cart.total_price || 0) : 0;
    if (state.cart) state.cart.items.forEach(function (it) { if (it.final_line_price > 0) { base += it.original_line_price; units += it.quantity; } });
    base += c.sum + addons; shipBase += c.total + addons; units += state.qty + (setBox && setBox.checked && sv ? 1 : 0);
    // Gratis-Armreif kombiniert nicht mit dem Duo-Code (AKTION2026) – dann keinen Armreif versprechen
    var duoCodeOn = !!(state.cart && ds.duoCode && (state.cart.discount_codes || []).some(function (d) { return d.code.toUpperCase() === ds.duoCode.toUpperCase(); }));
    var duoWins = duoActive && (state.qty === 2 || (state.qty >= 3 && !trioOff));
    var giftT = duoWins || (duoCodeOn && (state.qty < 3 || !trioOff)) ? 0 : gift;
    var shipFree = shipBase >= ship || (shipFrom2 && units >= 2), msg;
    if (!shipFree) msg = 'Noch ' + fmt(ship - shipBase) + ' bis zum Gratis-Versand' + (shipFrom2 ? ' – oder ab 2 Teilen' : '');
    else if (giftT && base >= giftT) msg = 'Gratis-Versand ✓ · Überraschungsarmreif gratis dazu' + (ds.giftValue ? ' (Wert ' + ds.giftValue + ')' : '');
    else if (giftT && giftT - base <= 3000) msg = 'Gratis-Versand ✓ · noch ' + fmt(giftT - base) + ' bis zum Gratis-Überraschungsarmreif';
    else msg = 'Gratis-Versand ✓';
    txt($('[data-spp-ship]'), msg);
  }

  /* ---------- In den Warenkorb ---------- */
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-SPC': '1' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Nicht verfügbar'); return j; }); });
  }
  function openCart(item, btn) {
    if (window.spCart && window.spCart.open) return window.spCart.open();
    try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn } })); } catch (e) {}
    var t = document.querySelector('.js-drawer-open-cart, [aria-controls="CartDrawer"]');
    if (t) t.click(); else location.href = '/cart';
  }
  function add(btn) {
    if (state.busy) return;
    var counts = {}, items = [];
    for (var i = 1; i <= state.qty; i++) { var id = state.slots[i] || state.slots[1]; counts[id] = (counts[id] || 0) + 1; }
    Object.keys(counts).forEach(function (id) { items.push({ id: parseInt(id, 10), quantity: counts[id] }); });
    var sv = setVariant(); if (setBox && setBox.checked && sv) items.push({ id: sv.id, quantity: 1 });
    if (wrapBox && wrapBox.checked && wrapVid && !wrapInCart()) items.push({ id: wrapVid, quantity: 1 });
    var err = $('[data-spp-err]'); err.hidden = true;
    state.busy = true; btn.setAttribute('aria-busy', 'true'); render();
    post('/cart/add.js', { items: items })
      .then(function (res) {
        if (state.qty >= 2 && duoActive && ds.duoCode) {
          try { sessionStorage.setItem('sp_duo', '1'); } catch (e) {}
          var code = state.qty >= 3 && ds.trioCode ? ds.trioCode : ds.duoCode;
          return post('/cart/update.js', { discount: code }).catch(function () {}).then(function () { return res; });
        }
        return res;
      })
      .then(function (res) { return openCart(res, btn); })
      .catch(function (e) { err.textContent = e.message || 'Das hat nicht geklappt – bitte erneut versuchen.'; err.hidden = false; })
      .then(function () { state.busy = false; btn.removeAttribute('aria-busy'); loadCart(); });
  }
  $('[data-spp-atc]').addEventListener('click', function () { add(this); });
  var sbtn = $('[data-spp-sticky-btn]'); if (sbtn) sbtn.addEventListener('click', function () { add($('[data-spp-atc]')); });

  function loadCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { state.cart = c; render(); }).catch(function () {});
  }
  document.addEventListener('cart:updated', function (e) { var c = e.detail && e.detail.cart; if (c && c.items) { state.cart = c; render(); } });

  /* ---------- Galerie ---------- */
  var track = $('[data-spp-track]'), dots = $$('[data-spp-dots] span');
  function goTo(i) { var s = track && $('[data-spp-slide="' + i + '"]', track); if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
  function cur() { return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0; }
  if (track) {
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { var c = cur(); dots.forEach(function (d, j) { d.classList.toggle('is-on', j === c); }); }, 60); }, { passive: true });
    var prev = $('[data-spp-prev]'), next = $('[data-spp-next]');
    if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, cur() - 1)); });
    if (next) next.addEventListener('click', function () { goTo(Math.min(dots.length - 1, cur() + 1)); });
  }

  /* ---------- Sticky-Leiste (mobil) ---------- */
  var sticky = $('[data-spp-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { var on = !e.isIntersecting && e.boundingClientRect.top < 0; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); });
    }).observe($('[data-spp-atc]'));
  }

  /* ---------- Sprung zu den Bewertungen ---------- */
  $$('[data-spp-jump]').forEach(function (a) {
    a.addEventListener('click', function (e) { var t = document.getElementById('spp-reviews'); if (!t) return; e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  });

  render();
  loadCart();
})();
